(function () {
	'use strict';

	angular.module('widgets.supplychain')
		.controller('lateDeliveryCausesChart', lateDeliveryCausesChart);

	function lateDeliveryCausesChart($rootScope, $scope, $filter, $uibModal, $timeout, $experiments,
			dashboardFilterInitializationService, leanFilterService, currencyFormatService, lateDeliveryCausesService, pageTimingService) {
		var reportConfig = {};
		var reportSettingsName = 'LateDeliveryCauses';

		// Set navigation properties
		$scope.emptyHeader = 'We couldn\'t find any results.';
		$scope.emptySuggestion = '';
		$scope.emptyLinkText = '';

		function init() {
			$scope.isSupplierPortal = (globalConfig.user.role === 'Supplier');
			$scope.tableName = 'LateDeliveryCauses';
			$scope.filterService = dashboardFilterInitializationService;
			$scope.leanFilterService = leanFilterService;
			$scope.initialLoad = true;
			$scope.initialReadFromConfig = true;
			$scope.loading = true;
			$scope.visibleMenu = 'top';
			$scope.allSelected = false;
			$scope.noneSelected = false;
			$scope.numberSelected = 0;
			$scope.applied = false;
			$scope.slideshowView = $rootScope.slideshowView;
			$scope.config.title = 'Late/early delivery causes';

			updateEventBind($scope, [
				'sideBarUpdate', 'lateDeliveryCausesChartChanged',
				'slideshowViewChanged'
			]);

			reportConfig.getChart = function () {
				var canLoad = true;
				for (var key in $scope.filterService.updating) {
					if ($scope.filterService.updating[key]) {
						canLoad = false;
						break;
					}
				}
				if (canLoad) {
					var columnDefinition = $scope.$parent.$parent.col;
					var curWidget = $scope.$parent.model;
					if (!$scope.slideshowView) {
						dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
					lateDeliveryCausesService.getChartData($scope.leanFilterService).then(function (data) {
						$scope.loading = false;
						$scope.initialLoad = false;

						if (!data || !data['data'] || !data['data'].length) {
							$scope.empty = true;
						} else {
							var groups = ['lateCustomerPos', 'lateVendorPos', 'earlyCustomerPos', 'earlyVendorPos'] ;
							var categories = [];
							var categoriesToId = {};
							angular.forEach(data.data, function (chartData) {
								categories.push(chartData.category);
								categoriesToId[chartData.category] = chartData.categoryNdx;
							});

							$scope.chartData = data.data;
							$scope.timeStampsByTimePeriod = data.timeStampsByTimePeriod;
							$scope.chartCategories = categories;
							$scope.chartGroups = groups;
							$scope.categoriesCount = categories.length;
							$scope.categoriesToId = categoriesToId;
							$scope.$broadcast('lateDeliveryCausesChartReady', null);
						}
						$rootScope.title = 'LeanDNA Dashboard - PO Late Delivery Causes';
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					});
				} else {
					$timeout(function () {
						reportConfig.getChart();
					}, 10);
				}
			};

			reportConfig.getChart();
		}

		init();
	}
})();
